import type { JSX } from 'preact';
import { useCallback, useRef, useState } from 'preact/hooks';
import { useChat } from '../hooks/useChat';
import { ChatPanel } from './ChatPanel';
import { Launcher } from './Launcher';

interface ChatWidgetProps {
  apiBaseUrl: string;
}

/** Root of the widget: a launcher that toggles the chat panel. */
export function ChatWidget({ apiBaseUrl }: ChatWidgetProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const launcherRef = useRef<HTMLButtonElement>(null);
  const chat = useChat(apiBaseUrl);

  // Closing returns focus to the launcher so keyboard users aren't stranded.
  const close = useCallback((): void => {
    setOpen(false);
    launcherRef.current?.focus();
  }, []);

  return (
    <>
      {open && <ChatPanel chat={chat} onClose={close} apiBaseUrl={apiBaseUrl} />}
      <Launcher
        open={open}
        onToggle={() => (open ? close() : setOpen(true))}
        buttonRef={launcherRef}
      />
    </>
  );
}
